define('views/content/payment',['require','backbone','marionette','views/components/manual_payment_transaction/manual_payment_transactions','collections/manual_payment_transactions','text!templates/content/payment.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var ManualPaymentTransactionsView = require('views/components/manual_payment_transaction/manual_payment_transactions');
    var ManualPaymentTransactionsCollection = require('collections/manual_payment_transactions');

    var temp = require("text!templates/content/payment.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-page',
        titleKey: 'payment_details',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            this.transactionsCollection = new ManualPaymentTransactionsCollection(this.model.get('transactions'));
        },

        regions: function() {
            return {
                TransactionsContainer: ".transaction-list"
            };
        },

        onRender: function() {
            this.TransactionsContainer.show(new ManualPaymentTransactionsView({
                collection: this.transactionsCollection
            }));
        }

    });
});
